import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';


export default function SocialBar() {
  return (
    <div className='social--wrapper'>
        <div className='social--icons'>
          <a href='https://twitter.com/jamesstbne'>
            <StaticImage alt=''  src='../../images/social/twitter.png'/>
            </a>
            <a href='https://www.facebook.com/jamesstbne'>
            <StaticImage  alt='' src='../../images/social/facebook.png'/>
            </a>
            <a href='https://instagram.com/jamesstbne'>
            <StaticImage alt=''  src='../../images/social/instagram.png'/>
            </a>
            <a href='https://www.pinterest.com/jamesstbne'>
            <StaticImage  alt='' src='../../images/social/pinterest.png'/>
            </a>
            
        </div>
    </div>
  );
}
